import { AfterViewChecked, AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubjectsService } from 'src/app/core/services/subjects.service';
import { environment } from 'src/environments/environment';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements AfterViewChecked, OnDestroy{

  private subs: SubSink;

  constructor(
    private readonly router: Router, private subjectServices: SubjectsService) {
      this.subjectServices.ocultarSidebarLoginSet = true;
  }

  ngOnDestroy(): void {
    this.subjectServices.ocultarSidebarLoginSet = false;
  }

  ngAfterViewChecked(): void {
    this.subjectServices.listadoRecursosAsideData = true;
    this.subjectServices.ocultarSidebarLoginSet = true;
  }


  public irInicio(): void {
    // this.router.navigateByUrl(constantes.REDIRECCIONAUTENTICACION);
    window.open(environment.caribbeanRedireccion, '_blank');
  }
}
